import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {collectWindowImageUrls} from '../util/collectSlideImageUrls';
import {currentSlideIndexSelector, loadedPresentationSelector, visibleSlideSelector} from '../store/selectors/presentation.selectors';
import {selectedDeviceTypeSelector} from '../store/selectors/layout.selectors';

export function usePreloadSlideImages(): void {
    const visibleSlides = useSelector(visibleSlideSelector);
    const currentSlideIndex = useSelector(currentSlideIndexSelector);
    const presentation = useSelector(loadedPresentationSelector);
    const device = useSelector(selectedDeviceTypeSelector);

    const urls = useMemo(
        () => collectWindowImageUrls(presentation, device, visibleSlides || [], currentSlideIndex),
        [presentation, device, visibleSlides, currentSlideIndex]
    );

    useEffect(() => {
        urls.forEach((url) => {
            const img = new Image();
            img.src = url;
        });
    }, [urls]);
}
